// Website-Eingaben kommen so, wie man sie diktiert: „www.kunde.de", „kunde.de".
// Ohne Schema ist das für den Browser eine RELATIVE Adresse — window.open
// landete damit auf /contacts/123/www.kunde.de statt beim Kunden.

/** Trimmt die Eingabe und ergänzt ein fehlendes Schema als `https://`. */
export function normalizeWebUrl(value: string | null | undefined): string {
  const wert = String(value ?? "").trim();
  if (!wert) return "";
  // Schema bereits vorhanden (http, https, aber auch mailto:/tel:) → unverändert.
  if (/^[a-z][a-z0-9+.-]*:/i.test(wert)) return wert;
  // Protokollrelativ („//kunde.de") bekommt schlicht das sichere Schema davor.
  if (wert.startsWith("//")) return `https:${wert}`;
  return `https://${wert}`;
}

/**
 * Maximale Länge eines gespeicherten Web-Werts: `ContactCommunication.value`
 * ist `varchar(100)` — längere Werte lässt der PUT scheitern.
 */
export const WEB_URL_MAX_LENGTH = 100;

/**
 * Wie {@link normalizeWebUrl}, aber für den zu SPEICHERNDEN Wert: Das Schema
 * wird nur ergänzt, wenn das Ergebnis noch in die Spalte passt. Sonst bleibt die
 * Eingabe unverändert — lieber ein schemaloser Wert als eine abgeschnittene und
 * damit kaputte URL. (Beispiel: 95 Zeichen ohne Schema + „https://" = 103.)
 */
export function normalizeWebUrlForStorage(
  value: string | null | undefined,
  maxLength: number = WEB_URL_MAX_LENGTH,
): string {
  const wert = String(value ?? "").trim();
  const normalisiert = normalizeWebUrl(wert);
  return normalisiert.length > maxLength ? wert : normalisiert;
}
